import { env } from "configs/EnvironmentConfig";
import fetchV2 from "auth/FetchInterceptorV2";

const reportManagementService = {};

// List Report
reportManagementService.listReport = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "maker_date",
    "maker.id",
    "maker.display_name",
    "checker_id",
    "checker_date",
    "checker.id",
    "checker.display_name",
    "resource_id",
    "resource.id",
    "resource.file_name",
    "resource.mine_type",
    "object_type",
    "record_status",
    "auth_status",
    "tenant_code",
    "creator_hub_id",
  ];

  return fetchV2({
    url: `${env.API_MSP}/reports`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker,resource",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Export Statistical Report
reportManagementService.exportStatisticalReport = ({ data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/reports`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Download Report
reportManagementService.downloadReport = ({
  fileId = undefined,
  fileName = "",
}) => {
  return fetchV2({
    url: `${env.API_MSP}/reports/download/${fileId}`,
    method: "get",
    responseType: "blob",
  });
};

// List Report
reportManagementService.listTypeReport = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/report-type`,
    method: "get",
    params: {
      ...params,
    },
  });
};

// Detail Report
reportManagementService.detailReport = ({
  reportId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/reports/${reportId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

export default reportManagementService;
